import { render, staticRenderFns } from "./index.vue?vue&type=template&id=166960e0"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksWrapper: require('/var/www/html/fantini/frontend-2/components/blocks-wrapper/index.vue').default})
